export const normalizeMoneyAmount = (value) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return 0;
  return Math.round((numericValue + Number.EPSILON) * 100) / 100;
};

export const truncateMoneyAmount = (value) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return 0;

  // Offset only floating-point noise near a cent boundary, then truncate.
  const scaledValue = numericValue * 100;
  return Math.trunc(scaledValue + Math.sign(scaledValue) * 1e-9) / 100;
};
